import cx from 'classnames'

import { VStack } from '@ui/layout/Stack'

import * as styles from './CallQualityFeedbackContent.css'

type CallQualityFeedbackContentProps = {
  children?: React.ReactNode
  className?: string
}

function CallQualityFeedbackContent({
  children,
  className,
}: CallQualityFeedbackContentProps) {
  return (
    <VStack gap={10} className={cx(styles.root, className)}>
      {children}
    </VStack>
  )
}

export default CallQualityFeedbackContent
